import { useParams } from 'react-router'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isNumber } from 'lodash'
import { textSubmissionDrawerActions } from '../../../../../store/slices/text-submission-drawer.slice'
import { useVersionId } from '../../../../../utils/parseURL.helper'

/**
 * Finds the Question that contains a specific QuestionRubric.
 */
const findQuestionByQuestionRubricId = (questions, questionRubricId) => {
    if (!questions || !questionRubricId) return null
    return questions.find(q => q.questionRubrics?.some(r => r.id === questionRubricId)) || null
}

const useExpandQuestionsManager = () => {
    const dispatch = useDispatch()
    const { token, layerId } = useParams()
    const questionRubricId = ['all', 'dashboard'].includes(layerId) ? null : parseInt(layerId)
    const versionId = useVersionId()

    const { data: questions } = useFetchQuestionsQuery({ token, versionId })

    useEffect(() => {
        if (!questions) return
        if (isNumber(questionRubricId)) {
            const question = findQuestionByQuestionRubricId(questions, questionRubricId)
            if (question) {
                dispatch(
                    textSubmissionDrawerActions.setExpandedQuestionIds([
                        question.id,
                        ...question.dependsOnQuestionIds,
                    ]),
                )
            }
        } else dispatch(textSubmissionDrawerActions.setExpandedQuestionIds(questions.map(q => q.id)))
        
    }, [questions, questionRubricId, dispatch])
}

export default useExpandQuestionsManager
